<template>
<el-dialog
    title="推荐菜"
    :visible="status"
    width="480px"
    @open="openInit"
    :close-on-click-modal="false"
    :before-close="esc">
    
    <div class="cont-row mrg-btm" v-if="dishClassList.length>0">
        <div class="lab">菜品类别</div>
        <div class="flex-cont">
            <el-select v-model="params.typeId" placeholder="请选择" :loading="dishClassLoading">
               
                <el-option
                v-for="item in dishClassList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
                </el-option>
            </el-select>
        </div>
    </div>
    <div class="cont-row mrg-btm">
        <div class="lab">菜名</div>
        <div class="flex-cont"><el-input v-model="params.name" placeholder="请输入菜名"></el-input></div>
    </div>
    <div class="cont-row mrg-btm">
        <div class="lab">价格</div>
        <div class="flex-cont"><el-input v-model.number="price" placeholder="请输入菜品价格"></el-input></div>
    </div>
    <div class="cont-row mrg-btm align-start">
        <div class="lab imgLab">图片</div>
        <div class="flex-cont">
            <div class="cont-row">
                <OnlyUploadImg :disabled="params.imageList.length >= 9" :limit="9-params.imageList.length"  @success="uploadSuccess" />
                <div class="note txt9 mrg-lf10">最多上传9张图片</div>
            </div>
            <div class="media-list">
                <div class="item" v-for="(item,index) in params.imageList" :key="index">
                    <div class="box">
                        <div class="remove" @click="removeImgAt(index)"><i class="el-icon-close"></i></div>
                        
                        <YorkbbsImage :src="item" aspect></YorkbbsImage>
                    </div>
                </div>
            </div>
        </div>
    </div>    
    <span slot="footer" class="dialog-footer">
        <el-button @click="esc" size="small">取 消</el-button>
        <el-button type="primary" @click="ensure" :loading="postLoading" size="small">确 定</el-button>
    </span>
</el-dialog>
</template>
<script>
import OnlyUploadImg from '@/common/only-uploadImg.vue';

export default {
    name:'AddSuggestDishDialog',
    props:['status','info'],
    components:{
        OnlyUploadImg,
    },
    data(){
        return  {
            infoShop:'',
            value:'',
            
            params:{
                postId:'',
                typeId:null,
                name:'',
                price:'',
                imageList:[],
                videoList:[],
            },
            price:'',
            postLoading:false,
            dishClassLoading:false,
            dishClassList:[],    
        }
    },
    methods:{
        openInit(){
            
            this.params.postId = this.info.id;
            this.getDishType();
        },
      
        async getDishType(){
            this.dishClassLoading = true;
            let result = await this.$axios.post('/comment/merchant/v1/get/dish/type/list/of/post',{postId:this.params.postId});
            this.dishClassLoading = false;
            
            if( result.code == 0 ){
                this.dishClassList = result.data.types;
            }
        },
        uploadSuccess(imgSrc){
            
            if( this.params.imageList.length <9 ){

                this.params.imageList.push(imgSrc);
            }
        },
        removeImgAt(index){
            this.params.imageList.splice(index,1);
        },
        esc(){
            if( this.postLoading ) return;
            this.$emit('update:status',false);
            this.params.typeId = null;
            this.params.name = '';
            this.params.price = '';
            this.params.imageList = [];
            this.params.videoList = [];
        },
        async ensure(){
            if( this.postLoading ) return;
            if( this.params.name.length == 0 ) return this.$warning('请填写推荐菜名');
            if( this.price == '') return this.$warning('请填写人均价格');
            if( this.params.imageList.length == 0 ) return this.$warning('请上传图片');
            let sendData = {...this.params};
            sendData.price = parseFloat(this.price);
            this.postLoading = true;
            let result = await this.$axios.post('/comment/frontend/v1/create/dish',sendData);
            this.postLoading = false;
            if( result.code == 0 ){
                this.$success('创建成功');
                this.esc();
                this.$emit('success');
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.cont-row{
    display: flex; align-items: center;
    &.mrg-btm{margin-bottom:20px;}
    &.align-start{align-items: flex-start;}
    .lab{
        width: 80px;line-height:40px;
        &.imgLab{line-height: 32px;}
    }
    .flex-cont{flex:1;overflow: hidden;}
    .note{color: #999; margin-left: 10px; }
    ::v-deep{
        .el-autocomplete{width: 100%;}
    }
    .media-list{
        margin:10px -5px 0; display: flex; flex-wrap: wrap;
        .item{
            padding: 0 5px; margin-bottom: 10px; width: 33.33%; box-sizing: border-box;
            .box{
                position: relative;
                video{width:100%; aspect-ratio: 4/3; object-fit: cover;}
                .remove{
                    position: absolute; z-index:3 ; top: 0; right: 0;  height: 20px; padding: 0 5px; background: #000; border-radius: 0 0 0 8px; font-size: 18px; color: #fff; cursor: pointer;
                }
            }
        }
    }
}
</style>